import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, PlusIcon, MinusIcon, UserRoundIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  role: string;
  quote: string;
  initial: string;
}
const TESTIMONIALS: Testimonial[] = [{
  name: 'S. Cesar',
  role: 'Office & home cleaning',
  quote: "Good and reliable service. I'm happy to have them to clean my messy office. I recommend them for their best cleaning services!",
  initial: 'S'
}, {
  name: 'Danna J.',
  role: 'Spotless apartment',
  quote: 'Ally cleaned my apartment and left it spotless. Amazing service and very professional.',
  initial: 'D'
}, {
  name: 'Elena J.',
  role: 'Professional & punctual',
  quote: 'I had an excellent experience with Ally Cleaning Services! Their team was professional, punctual, and did an outstanding job.',
  initial: 'E'
}];
interface FAQ {
  q: string;
  a: string;
}
const FAQS: FAQ[] = [{
  q: 'Do I need to provide cleaning supplies?',
  a: 'No. We bring everything needed for a premium clean, including professional-grade supplies and equipment.'
}, {
  q: 'Are you pet friendly?',
  a: 'Yes — we love pets and use thoughtful practices to keep your furry family members comfortable and safe.'
}, {
  q: 'What is your cancellation policy?',
  a: 'We kindly require 24 hours’ notice. Appointments cancelled with less notice are subject to a 50% fee.'
}, {
  q: 'Do you offer Deep Cleaning?',
  a: 'Yes. We recommend a Deep Cleaning for first visits so we can establish the immaculate boutique standard your home deserves.'
}, {
  q: 'How do I pay?',
  a: 'For your convenience, we accept Zelle, Cash, and all major credit and debit cards.'
}, {
  q: 'Do you do laundry?',
  a: 'Yes. Laundry service is available as a tailored add-on to your cleaning appointment.'
}, {
  q: 'Are you insured?',
  a: 'Yes. Our team is professionally insured, so you can enjoy complete peace of mind.'
}, {
  q: 'What areas do you serve?',
  a: 'We proudly serve Manhattan, Queens, and Long Island.'
}, {
  q: 'Can I trust you with my keys?',
  a: 'Absolutely. We use secure key-management practices and the utmost discretion in every home we enter.'
}, {
  q: 'Do you offer organic products?',
  a: 'Yes. Organic and eco-conscious products are available upon request for a clean that feels good in every sense.'
}];
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-250" data-mp="208om0w7vqq4e">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-magenta text-magenta" data-id="element-251" data-mp="252strhoyz26j" data-mpi={i} />)}
    </div>;
}
export function SocialProof() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white" data-id="element-252" data-mp="2ewswjcws3vc3">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-[6.4rem]" data-id="element-253" data-mp="2jxgyuuqgjylm">
        {/* Testimonials */}
        <div className="mx-auto max-w-2xl text-center" data-id="element-254" data-mp="8awxcxftno6s">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-magenta" data-id="element-255" data-mp="88aew2re7o9s">
            Loved by New Yorkers
          </span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate" data-id="element-256" data-mp="3uh1x0lorfo2u">
            What our clients say
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:mt-14 md:grid-cols-3" data-id="element-257" data-mp="r14vt28ktqgn">
          {TESTIMONIALS.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className="relative flex flex-col rounded-3xl bg-slate-50 p-8 ring-1 ring-slate-100" data-id="element-258" data-mp="m1i8u12y4vun" data-mpi={i}>
              <div className="flex items-start justify-between gap-4" data-id="element-259" data-mp="pl8xrrqtx5b2">
                <Stars data-id="element-260" data-mp="ujah8ds636n2" />
                <span aria-label="Google review" className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-white font-display text-sm font-extrabold text-[#4285f4] shadow-sm ring-1 ring-slate-100" data-id="element-261" data-mp="ufmohgujqo9e">
                  G
                </span>
              </div>
              <blockquote className="mt-5 flex-1 text-slate-soft leading-relaxed" data-id="element-262" data-mp="1d909at4jpeba">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3" data-id="element-263" data-mp="yj1d2vwjwcyg">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-magenta ring-1 ring-slate-200" data-id="element-264" data-mp="13hvv3vmp1xhi">
                  <UserRoundIcon className="h-5 w-5" aria-hidden="true" data-id="element-265" data-mp="1r65buj51vv1s" />
                  <span className="sr-only" data-id="element-266" data-mp="1vzqdqm9rl969">{t.initial}</span>
                </span>
                <div data-id="element-267" data-mp="3goc0kfew5kl5">
                  <p className="font-display text-sm font-bold text-slate" data-id="element-268" data-mp="3gnstxuuoyimf">
                    {t.name}
                  </p>
                  <p className="text-xs text-slate-muted" data-id="element-269" data-mp="3bog5x6s335i9">{t.role}</p>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>

        {/* FAQ */}
        <div id="faq" className="mx-auto mt-12 max-w-3xl sm:mt-[4.8rem]" data-id="element-270" data-mp="3li6ro3wtt1u9">
          <div className="text-center" data-id="element-271" data-mp="2xr1ddt6jahm2">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-brand" data-id="element-272" data-mp="2srep8op63gyh">
              FAQ
            </span>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate" data-id="element-273" data-mp="36rfyosjhzwpk">
              Questions, answered
            </h2>
          </div>

          <div className="mt-10 divide-y divide-slate-100 rounded-3xl ring-1 ring-slate-100" data-id="element-274" data-mp="m0oyni82e81f">
            {FAQS.map((faq, i) => {
            const isOpen = open === i;
            return <div key={faq.q} data-id="element-275" data-mp="3au3xqssj9j7r" data-mpi={i}>
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-276" data-mp="3assls5oxp55k">
                    <span className="font-display text-base font-semibold text-slate" data-id="element-277" data-mp="3otwnaksbpte5">
                      {faq.q}
                    </span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-magenta-soft text-magenta" data-id="element-278" data-mp="2s19gttbcnh0w">
                      {isOpen ? <MinusIcon className="h-4 w-4" data-id="element-279" data-mp="312zh7on7lqat" /> : <PlusIcon className="h-4 w-4" data-id="element-280" data-mp="35v0qr2szt2x5" />}
                    </span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-281" data-mp="29ccwah5r82vv">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.28
                }} className="overflow-hidden" data-id="element-282" data-mp="2dd55xbijg9so">
                        <p className="px-6 pb-5 text-slate-soft leading-relaxed" data-id="element-283" data-mp="1i39t64az3ezy">
                          {faq.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}